import { GOOGLE_LOGIN } from "../configs/routes";
import api from "./api";

export const loginWithGoogleUser = (googleUser) =>
  api.post(GOOGLE_LOGIN, googleUser).then((response) => response.data);
